import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  GenericList,
  LoadingAnimation,
  ConfirmationPopup,
  AdditionalProductCategoryListContent,
  ProductCategory,
  useShowAlertPopup,
  FilterListInput,
} from '@dew21/ui';
import axios from 'axios';
import { useHistory } from 'react-router';

export const ProductCategories: FC = (props) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [productCategories, setProductCategories] = useState<ProductCategory[] | null>(null);
  const [filteredProductCategories, setFilteredProductCategories] = useState<ProductCategory[] | null>(null);
  const [selectedProductCategory, setSelectedProductCategory] = useState<ProductCategory | null>(null);
  const [showDeleteProductCategoryDialog, setShowDeleteProductCategoryDialog] = useState<boolean>(false);
  const showNotificationBanner = useShowAlertPopup();

  const fetchProductCategories = () => {
    return axios.get('/api/product/category/all');
  };

  useEffect(() => {
    setIsLoading(true);
    fetchProductCategories().then((response) => {
      setProductCategories(response.data);
      setFilteredProductCategories(response.data);
      setIsLoading(false);
    }).catch((error) => {
      console.log(error);
      setIsLoading(false);
    });
  }, []);

  return <>
    <ConfirmationPopup config={{
      open: showDeleteProductCategoryDialog,
      actionButtonLabel: 'Kategorie löschen',
      closeFn: () => {
        setSelectedProductCategory(null);
        setSelectedProductCategory(null);
        setShowDeleteProductCategoryDialog(false);
      },
      actionFn: () => {
        axios.delete(`/api/product/category/${selectedProductCategory && selectedProductCategory.id}`)
          .then((response) => {
            setProductCategories(response.data);
            setSelectedProductCategory(null);
            setShowDeleteProductCategoryDialog(false);
            showNotificationBanner({ renderContent: () => <>Die Kategorie wurde gelöscht.</> });
          })
          .catch((error) => {
            showNotificationBanner({
              error: true,
              renderContent: () => <>Die Kategorie konnte nicht gelöscht werden.</>,
            });
            setSelectedProductCategory(null);
            setShowDeleteProductCategoryDialog(false);
          });
      },
      renderer: () => (
        <p>Sind Sie sich sicher, dass sie die
          Kategorie {selectedProductCategory && selectedProductCategory.name} löschen wollen? Alle dazugehörigen
          Produkte werden ebenfalls gelöscht ...</p>
      ),
    }}/>
    <PageWrapper
      breadCrumb={[{ title: 'Produkte', path: '/products' }]}
      marginal={{
        items: [
          {
            text: 'Produktkategorie hinzufügen',
            icon: 'add-user',
            route: '/products/category/new',
          }, {
            text: 'Produkt hinzufügen',
            icon: 'add-user',
            route: '/products/new',
          }],
      }}>
      {
        (productCategories && productCategories.length > 0) && <FilterListInput
          id={'filter-product-categories'}
          label={'Produktsuche'}
          onChange={(value: string | null) => {
            if (value && productCategories) {
              const condition = productCategories.map((productCategory) => {
                return {
                  ...productCategory,
                  products: productCategory.products.filter((product) => {
                    const matchingString = `${product.name}`.toLowerCase();
                    if (matchingString.includes(value.toLowerCase())) {
                      return product;
                    }
                  }).filter((product) => product !== null),
                };
              }).filter((productCategory) => productCategory !== null && productCategory.products.length > 0) || productCategories;
              setFilteredProductCategories(condition);
            } else {
              setFilteredProductCategories(productCategories);
            }
          }}
          placeholder={'Produktname'}/>
      }
      {
        (filteredProductCategories && filteredProductCategories.length > 0 && !isLoading) ?
          <GenericList
            displayColumnNames={true}
            collapsible={true}
            additionalRenderFn={(item: ProductCategory) => (
              <AdditionalProductCategoryListContent
                item={item}
                deleteHook={() => {
                  setSelectedProductCategory(item);
                  setShowDeleteProductCategoryDialog(true);
                }}
                updateHook={() => {
                  history.push(`/products/category/${item.id}`);
                }}/>
            )}
            columns={[{ name: 'name', displayName: 'Produktkategorien', sortable: false }]}
            items={filteredProductCategories}
            countLabel={`${filteredProductCategories.length} Kategorien gefunden`}/>
          : <>Keine Kategorien gefunden</>
      }
      {
        isLoading && <LoadingAnimation transparent overlay/>
      }
    </PageWrapper>
  </>;
};
